import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import screen from 'superior-mq';
import { rem } from 'polished';
import { megaText, bp } from 'Styles/helpers';
import Grid from '../../grid';

const gridStyles = `
  ${screen.below(bp.portrait, `
    grid-row-gap: 20px;
  `)}
`;

const gridItemStyles = `
  ${screen.below(bp.portrait, `
    grid-column: 2 / span 10;
  `)}

   ${screen.below(bp.mobileSm, `
    grid-column: span 12;
  `)}
`;

const rightGridItemStyles = `

  ${screen.below(bp.tablet, `
    grid-column: span 8;
  `)}

  ${gridItemStyles}
`;

const FormGrid = ({ children, number }) => (
  <Grid styles={gridStyles}>
    <Grid.Item span={4} styles={gridItemStyles}>
      <SectionNumber role="presentation">{number}</SectionNumber>
    </Grid.Item>
    <Grid.Item span={6} styles={rightGridItemStyles}>
      {children}
    </Grid.Item>
  </Grid>
);

FormGrid.propTypes = {
  children: PropTypes.node,
  number: PropTypes.string,
};

const SectionNumber = styled.span`
  ${megaText()}
  color: ${props => props.theme.blue};

  ${screen.below(bp.portrait, `
    font-size: ${rem(64)};
  `)}
`;

export default FormGrid;
